import{addClass}from"@olmokit/dom/addClass";import{off}from"@olmokit/dom/off";import{on}from"@olmokit/dom/on";import{removeClass}from"@olmokit/dom/removeClass";import{toArray}from"@olmokit/dom/toArray";import{getElementRules,getElementWrapper}from"../helpers";import{isEmail,isFilesize,isRequired}from"../validators";let DEFAULT_VALIDATORS={required:{validate:isRequired,msg:""},email:{validate:isEmail,msg:""},file:{validate:isFilesize,msg:""}},CLASSNAME_INVALID="invalid",CLASSNAME_VALID="valid",CLASSNAME_TOUCHED="touched";/**
 * Set form element as valid ("manually")
 */export function setAsValid($element){let wrapper=getElementWrapper($element);removeClass(wrapper,CLASSNAME_INVALID),addClass(wrapper,CLASSNAME_VALID)}/**
 * Set form element as invalid ("manually")
 */export function setAsInvalid($element){let wrapper=getElementWrapper($element);addClass(wrapper,CLASSNAME_INVALID),removeClass(wrapper,CLASSNAME_VALID)}/**
 * Validation
 *
 * Native API is:
 * ```
 * element.setCustomValidity("error message");
 * element.checkValidity(); // returns boolean
 * element.reportValidity(); // shows error message
 * ```
 *
 * The validity object for e.g. a textarea is:
 * ```
 * textarea.validty = {
 *   badInput: false,
 *   customError: false,
 *   patternMismatch: false,
 *   rangeOverflow: false,
 *   rangeUnderflow: false,
 *   stepMismatch: false,
 *   tooLong: false,
 *   tooShort: false,
 *   typeMismatch: false,
 *   valid: false,
 *   valueMissing: false
 * }
 * ```
 *
 * @see https://caniuse.com/#search=form%20valid for native support
 */export function Validation(form,{validators={},onsuccess,onerror}){// @ts-expect-error FIXME: core types
let allValidators={...DEFAULT_VALIDATORS,...validators},elements=toArray(form.elements).filter(el=>"BUTTON"!==el.tagName);// remove native HTML5 validation, leave it in HTML for no JS support
form.setAttribute("novalidate","true"),// bind submit event
on(form,"submit",handleSubmit);// bind input events
for(let i=0;i<elements.length;i++){let input=elements[i];on(input,"keyup",setTouchState),on(input,"keyup",validateElementIfTouched),on(input,"blur",validateElementIfTouched),on(input,"change",validateElement)}/**
   * Set touch state and immediately deregister listener, don't consider pressing
   * the TAB key as an actual typing input
   */function setTouchState(event){if(9!==event.keyCode){// 9 is TABKEY
let wrapper=getElementWrapper(this);addClass(wrapper,CLASSNAME_TOUCHED),off(this,"keyup",setTouchState)}}/**
   * Validate Form element only if it has been already touched
   */function validateElementIfTouched(){let wrapper=getElementWrapper(this);return wrapper.classList.contains(CLASSNAME_TOUCHED)?validateElement.call(this):[]}/**
   * Validate Form element
   */function validateElement(){let wrapper=getElementWrapper(this),rules=getElementRules(this),errors=[],i=0;for(;i<rules.length;){let rule=rules[i],validator=allValidators[rule];if(!this.disabled&&!validator.validate(this)){addClass(wrapper,CLASSNAME_INVALID),removeClass(wrapper,CLASSNAME_VALID),errors.push({element:this,name:rule,msg:validator.msg});break}removeClass(wrapper,CLASSNAME_INVALID),addClass(wrapper,CLASSNAME_VALID),i++}return errors}/**
   * Handle form submit
   */function handleSubmit(event){let errors=[];for(let i=0;i<elements.length;i++)errors=errors.concat(validateElement.call(elements[i]));if(errors.length){onerror&&onerror(errors),event.preventDefault();return}if(onsuccess){onsuccess(),event.preventDefault();return}}return{destroy(){// bind submit event
off(form,"submit",handleSubmit);// bind input events
for(let i=0;i<elements.length;i++){let input=elements[i];off(input,"keyup",setTouchState),off(input,"keyup",validateElementIfTouched),off(input,"blur",validateElementIfTouched),off(input,"change",validateElement)}}}}export default Validation;